import { useState } from "preact/hooks";
import { GET, GET_RESERVE_OPTION } from "../../../services";
import { IStateOptionsReservation } from "../interfaces/state";

export const useGetOption = () => {
  const [optionsReserve, setOptionsReserve] = useState(
    [] as IStateOptionsReservation[]
  );

  const onFetchOptionsReserve = async () => {
    try {
      const res = await GET(GET_RESERVE_OPTION);
      const { options } = res.result;
      setOptionsReserve(options);
    } catch (error) {
      console.log(error);
    }
  };

  return {
    onFetchOptionsReserve,
    optionsReserve,
  };
};
